export default "__VITE_ASSET__31f2875e__"